import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Logo } from "@/components/Logo";
import { Mail, Lock } from "lucide-react";

export default function Login() {
    const { login } = useAuth();
    const nav = useNavigate();
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [error, setError] = useState("");
    const [busy, setBusy] = useState(false);

    const submit = async (e) => {
        e.preventDefault();
        setBusy(true);
        setError("");
        const res = await login(email, password);
        setBusy(false);
        if (res.ok) nav("/dashboard");
        else setError(res.error);
    };

    return (
        <div className="grid min-h-screen md:grid-cols-2">
            <div className="relative hidden md:block">
                <img
                    src="https://images.unsplash.com/photo-1502602898657-3e91760cbb34?w=1400"
                    alt="Travel"
                    className="absolute inset-0 h-full w-full object-cover"
                />
                <div className="absolute inset-0 bg-gradient-to-br from-ink/50 to-terracotta/30" />
                <div className="absolute bottom-10 left-10 right-10 text-sand">
                    <p className="overline text-sand/80">welcome back</p>
                    <p className="mt-3 font-display text-4xl leading-tight">“Travel is the only thing you buy that makes you richer.”</p>
                </div>
            </div>
            <div className="flex flex-col items-center justify-center bg-sand px-6 py-12">
                <div className="w-full max-w-sm">
                    <Logo />
                    <h1 className="mt-10 font-display text-4xl text-ink">Welcome back.</h1>
                    <p className="mt-2 text-moss">Sign in to plan your next trip.</p>

                    <form onSubmit={submit} className="mt-8 space-y-4" data-testid="login-form">
                        <label className="flex items-center gap-3 rounded-2xl bg-white px-4 py-3 ring-1 ring-jade/15 focus-within:ring-terracotta/40">
                            <Mail size={16} className="text-jade" />
                            <input
                                data-testid="login-email"
                                type="email"
                                required
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                placeholder="you@email.com"
                                className="w-full bg-transparent outline-none"
                            />
                        </label>
                        <label className="flex items-center gap-3 rounded-2xl bg-white px-4 py-3 ring-1 ring-jade/15 focus-within:ring-terracotta/40">
                            <Lock size={16} className="text-jade" />
                            <input
                                data-testid="login-password"
                                type="password"
                                required
                                minLength={6}
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                placeholder="••••••••"
                                className="w-full bg-transparent outline-none"
                            />
                        </label>
                        {error && (
                            <p data-testid="login-error" className="rounded-2xl bg-destructive/10 px-4 py-2 text-sm text-destructive">{error}</p>
                        )}
                        <button
                            type="submit"
                            disabled={busy}
                            data-testid="login-submit"
                            className="btn-primary w-full justify-center !py-4"
                        >
                            {busy ? "Signing in…" : "Sign in"}
                        </button>
                    </form>

                    <p className="mt-6 text-sm text-moss">
                        New to Werighty?{" "}
                        <Link to="/register" data-testid="login-go-register" className="text-terracotta hover:underline">Create an account</Link>
                    </p>
                    <p className="mt-2 text-xs text-moss/70">Demo: admin@werighty.com / admin12345</p>
                </div>
            </div>
        </div>
    );
}
